import React from 'react'

import { ReactComponent as MoreIcon} from '../../../static/images/more.svg'

import './styles.scss'
import useOutsideClick from '../../../context/useOutsideClick'
import Button, { ButtonSize, ButtonVariant } from '../button'
import {
  getDropdownOptionsClassName,
  type DropdownOpenDirection,
} from './dropdownDirection'

export {
  getDropdownOptionsClassName,
  type DropdownOpenDirection,
} from './dropdownDirection'

type Props = {
  children: React.ReactNode
  buttonLabel?: React.ReactNode
  buttonSize?: ButtonSize
  /** Default opens below the trigger; `up` opens above (e.g. bottom action bar). */
  openDirection?: DropdownOpenDirection
}

const Dropdown: React.FC<Props> = ({
  children,
  buttonLabel,
  buttonSize = ButtonSize.AUTO,
  openDirection = 'down',
}) => {
  const [showDropdown, setShowDropdown] = React.useState(false)

  const handleOutsideClick = () => setShowDropdown(false)
  const ref = useOutsideClick(handleOutsideClick) as React.RefObject<HTMLDivElement>

  const toggleDropdown = () => {
    setShowDropdown(!showDropdown)
  }

  const closeDropdown = () => setShowDropdown(false)

  const iconSize = buttonSize === ButtonSize.SMALL ? 21 : 24
  return (
    <div className='dropdown-container' ref={ref}>
      <Button
        as='dropdown'
        type='button'
        variant={ButtonVariant.LIGHT}
        size={buttonSize}
        mobileWidth='full'
        onClick={toggleDropdown}
        aria-expanded={showDropdown}
        aria-haspopup='true'
        aria-label='More actions'
        icon={<MoreIcon width={iconSize} height={iconSize} />}
        iconPosition='start'
      >
        {buttonLabel}
      </Button>
      {showDropdown && (
        <div className={getDropdownOptionsClassName(openDirection)} onClick={closeDropdown}>
          {children}
        </div>
      )}
    </div>
  )
}

export default Dropdown
